import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'amenities-view',
    templateUrl: './amenities-view.component.html',
    styleUrls: ['./amenities-view.component.scss']
})
export class AmenitiesViewComponent implements OnInit {

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/amenities-view/amenities-view.component.ts